const { useState, useEffect } = require('react')

const BREAKPOINTS = {
    small: 576,
    medium: 768,
    large: 992,
    extraLarge: 1200,
    extraExtraLarge: 1400
}

const useResponsive = (breakpoint = BREAKPOINTS.extraLarge) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= breakpoint)
        }

        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [breakpoint])

    return isMobile
}

module.exports = { useResponsive, BREAKPOINTS }
